import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { AssignmentLateIcon } from '@/components/icons'
import { FavoriteIcon } from '@/components/icons/FavoriteIcon'
import { ScheduleOutlinedIcon } from '@/components/icons/ScheduleOutlined'
import { SearchFilledIcon } from '@/components/icons/SearchFilled'
import { PageWithHeader, PageWrapper } from '@/components/layout'
import { Icon, IconWrapper, Image, LinkButton } from '@/components/ui'
import { ROUTE } from '@/const'

export const TopPage = () => {
  const { t } = useTranslation()

  return (
    <PageWithHeader withSearch={true}>
      <PageWrapper withBreadcrumb={false} spacingX={'sm'}>
        <div className={clsx('tw-mt-16', 'tw-flex tw-flex-col tw-gap-4')}>
          <div className={clsx('tw-mt-8')}>
            <div
              className={clsx(
                'tw-relative',
                'after:tw-absolute',
                'tw-left-0',
                'after:tw-top-[-73px]',
                'after:tw-block',
                "after:tw-content-['']",
                'after:tw-h-[75px] after:tw-w-[96px] after:tw-bg-kikumaTel',
                'after:tw-bg-contain'
              )}
            >
              <LinkButton
                href={ROUTE.orderHistories}
                variant={'secondary'}
                size={'xl'}
              >
                <div className={clsx('tw-flex tw-flex-col tw-items-center')}>
                  <div className={clsx('tw-flex tw-items-center tw-space-x-2')}>
                    <IconWrapper>
                      <Icon icon={ScheduleOutlinedIcon} size={'2xl'} />
                    </IconWrapper>
                    <span>{t('top.menu.orderHistory')}</span>
                  </div>
                </div>
              </LinkButton>
            </div>
          </div>
          <div className={clsx('tw-flex tw-items-center tw-gap-2')}>
            <LinkButton
              href={ROUTE.favorites}
              variant={'secondary'}
              size={'xl'}
            >
              <IconWrapper>
                <FavoriteIcon size={24} type="empty" />
              </IconWrapper>
              <span>{t('top.menu.favorite')}</span>
            </LinkButton>
            <LinkButton href={ROUTE.search} variant={'secondary'} size={'xl'}>
              <IconWrapper>
                <Icon icon={SearchFilledIcon} size={'2xl'} />
              </IconWrapper>
              <span>{t('top.menu.search')}</span>
            </LinkButton>
          </div>
          <div className={clsx('tw-flex tw-items-center tw-gap-2')}>
            <LinkButton
              href={ROUTE.backorders}
              variant={'secondary'}
              size={'xl'}
            >
              <IconWrapper>
                <Icon icon={AssignmentLateIcon} size={'2xl'} />
              </IconWrapper>
              <span>{t('top.menu.backorders')}</span>
            </LinkButton>
          </div>
        </div>
        <div className={clsx('tw-mt-1', 'tw-flex tw-justify-end')}>
          <div className={clsx('tw-h-[169px] tw-w-[124px]')}>
            <Image src="/images/kikumi_cart.png" alt="" isEventNone={true} />
          </div>
        </div>
      </PageWrapper>
    </PageWithHeader>
  )
}
